exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scoped-small-border[data-v-a70d27f4]{border:1px solid hsla(0,0%,72.2%,.8);padding:1rem;border-radius:4px}.scope-border-open-top[data-v-a70d27f4]{border-left:1px solid #cfcfcf;border-right:1px solid #cfcfcf;border-bottom:1px solid #cfcfcf}.scoped-fit-padding[data-v-a70d27f4]{padding-left:15px;padding-right:15px;padding-bottom:5px}", ""]);

// exports
